import { useApiClient } from '@/lib/api/hooks/use-api-client';

/**
 * Provider component to initialize the API client with Clerk authentication
 * This should wrap the app to ensure the API client has access to auth tokens
 */
export function ApiClientProvider({ children }: { children: React.ReactNode }) {
  useApiClient();
  return <>{children}</>;
}

